import { gsap, Power2, Linear } from 'gsap'
import { ScrollTrigger }        from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function isMobile ()
{
	return (innerWidth < 1300)
}

document.querySelectorAll('header[data-header]').forEach(section =>
{
	section.querySelectorAll('.text, .button').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'left'
		el.dataset.reveal_delay = index.toString()
	})
	
	section.querySelectorAll('.forme').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'right'
		el.dataset.reveal_delay = index.toString()
	})
	
	section.querySelectorAll('.scroll').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
	
	section.querySelectorAll('.col_img').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'right'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-text]').forEach(section =>
{
	section.querySelectorAll('h1, h2, h3, p, ul').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-text_photo]').forEach(section =>
{
	section.querySelectorAll('.col').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		if (section.classList.contains('photo_right'))
		{
			el.classList.add('reveal')
			el.dataset.reveal_from = el.classList.contains('col_img') ? 'right' : 'left'
			el.dataset.reveal_delay = index.toString()
		}
		else
		{
			el.classList.add('reveal')
			el.dataset.reveal_from = el.classList.contains('col_img') ? 'left' : 'right'
			el.dataset.reveal_delay = index.toString()
		}
	})
	
	section.querySelectorAll('.scroll').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-text_photo_circle]').forEach(section =>
{
	section.querySelectorAll('.col').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = el.classList.contains('col_img') ? 'right' : 'left'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-services]').forEach(section =>
{
	section.querySelectorAll('h2, p').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
	
	section.querySelectorAll('.item').forEach((el, index) =>
	{
		el.querySelectorAll('.background, h3, .button').forEach((_el, index) =>
		{
			index = (index === 0) ? index : (index / 15)
			
			_el.classList.add('reveal')
			_el.dataset.reveal_from = 'bottom'
			_el.dataset.reveal_delay = index.toString()
		})
	})
	
	section.querySelectorAll('.logo_icon').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'scale_rotate'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-frontpage_text]').forEach(section =>
{
	section.querySelectorAll('h2, h3, p, ul').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
	
	section.querySelectorAll('.forme').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = el.classList.contains('lines') ? 'right' : 'left'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-frontpage_services]').forEach(section =>
{
	section.querySelectorAll('h2, p, .photo, .button').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
	
	section.querySelectorAll('.forme').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = el.classList.contains('bleue') ? 'right' : 'left'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-frontpage_clients]').forEach(section =>
{
	section.querySelectorAll('h2, .slider').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-frontpage_news]').forEach(section =>
{
	section.querySelectorAll('h2, .slider, .link').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
	
	section.querySelectorAll('.forme').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = el.classList.contains('verte') ? 'right' : 'left'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-frontpage_contact]').forEach(section =>
{
	section.querySelectorAll('.text h2, .text p, form').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-form]').forEach(section =>
{
	section.querySelectorAll('form').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
})

function hide (el)
{
	gsap.set(el, { autoAlpha: 0 })
}

function animate (el, direction)
{
	direction = direction || 1
	
	const offset = 400
	let x = 0, y = 0, scale = false, rotate = false
	let delay = el.dataset.reveal_delay || 0
	
	if (delay > 0.5)
	{
		delay = 0.5
	}
	
	if (el.dataset.reveal_from === 'left')
	{
		x = -offset
	}
	if (el.dataset.reveal_from === 'right')
	{
		x = offset
	}
	if (el.dataset.reveal_from === 'bottom')
	{
		y = (offset / 3) * direction
	}
	if (el.dataset.reveal_from === 'scale')
	{
		scale = true
	}
	if (el.dataset.reveal_from === 'scale_rotate')
	{
		scale = true
		rotate = true
	}
	
	const transition = gsap.getProperty(el, 'transition')
	
	gsap.set(el, {
		transition: 'none'
	})
	
	gsap.fromTo(el, { x: x, y: y, scale: scale ? 0 : 1, rotation: rotate ? -180 : 0, autoAlpha: 0 }, {
		duration: .8,
		delay: delay,
		x: 0,
		y: 0,
		scale: 1,
		rotation: 0,
		autoAlpha: 1,
		ease: Power2.easeOut,
		overwrite: 'auto',
		onComplete: () =>
		{
			gsap.set(el, {
				transition: transition
			})
		}
	})
}

let delay = 0

gsap.utils.toArray('.reveal').forEach(function (el, index)
{
	hide(el)
	
	ScrollTrigger.create({
		trigger: el,
		start: 'top bottom',
		onEnter: (self) =>
		{
			animate(el, null, delay)
			self.disable()
		}
	})
})

function getOffset (el)
{
	return {
		x: el.getBoundingClientRect().x + window.scrollX,
		y: el.getBoundingClientRect().y + window.scrollY
	}
}
